class ConfigCaptions {
    enable = false;

    constructor() {
        Object.seal(this);
    }
}

export default ConfigCaptions;
